import React from "react";
import { Outlet } from "react-router-dom";
import BusinessGroupListData from "./businessGroupListData/BusinessGroupListData";
import TopHeaderBusiness from "../../../../../components/general/TopHeaderBusiness";

const BusinessGroupList = () => {
    return (
        <>
            {/* <TopHeaderBusiness /> */}
            <div className="row">
                <div className="col-md-12">
                    <BusinessGroupListData />
                </div>
                <div className="col-md-12">
                    <Outlet />
                </div>
            </div>

        </>

    );
};

export default BusinessGroupList;
